import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import LinkChevron from '../../../02_molecules/Link/LinkChevron';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

/**
 * Deprecated after migration to the new Knowledge Hub.
 */
const BBPublicationAuthor = ({
  image = { url: '', alt: '' },
  name = '',
  nextLink = null,
  position = '',
  email = '',
  additionalInfo = '',
  behaviorSettings = null,
}) => (
  <div
    className={`bb bb-publication-author ${
      styles['bb-publication-author']
    } ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
  >
    <div className="container">
      <div className="row">
        {image && (
          <div className="col-12 col-md-auto">
            <img
              className="avatar"
              src={image.url}
              alt={image.alt}
              title={image.alt}
              width={120}
              height={120}
            />
          </div>
        )}

        <div className="col-12 col-md-6 me-md-auto">
          {name && (
            <p className="name">
              {nextLink && <LinkChevron label={name} nextLink={nextLink} />}
              {!nextLink && <>{name}</>}
            </p>
          )}

          {position && <p className="position">{position}</p>}

          {additionalInfo && <div className="info">{additionalInfo}</div>}

          {email && (
            <div className="email">
              <a href={`mailto:${email}`}>{email}</a>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

BBPublicationAuthor.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  name: PropTypes.string,
  nextLink: PropTypes.shape(linkPropTypes),
  position: PropTypes.string,
  email: PropTypes.string,
  additionalInfo: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
};

export default BBPublicationAuthor;
